import type { SafeAny } from '@trg/utils';
import { ApiContextProvider } from '@trg/api';
import { Headline, type HeadlineProps } from '@trg/tlw-ui-component';
import {
  createReactApp,
  createTailwindLink,
  registerCustomElement,
} from '../utils';

const CUSTOM_BREADCRUMB_TAG_NAME = 'custom-breadcrumb';

class CustomBreadcrumb extends HTMLElement {
  constructor() {
    super();

    this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    if (!this.shadowRoot) return;

    const tailwindLink = createTailwindLink({
      environment: process.env['NODE_ENV'] as SafeAny,
    });

    this.shadowRoot.appendChild(tailwindLink);

    const attribute = this.getAttribute('headlineProps') || '{}';
    const headlineProps = JSON.parse(attribute);

    createReactApp(
      this.shadowRoot,
      <ApiContextProvider value={{ host: process.env['TLW_API_HOST'] }}>
        <Headline {...headlineProps} />
      </ApiContextProvider>
    );
  }
}

export type NewBreadcurmbProps = Omit<
  HeadlineProps,
  'hasWrapClass' | 'children'
>;

export function NewBreadcrumb({
  mainTitle,
  subtitle,
  breadcrumbs,
  ...props
}: NewBreadcurmbProps) {
  registerCustomElement(CUSTOM_BREADCRUMB_TAG_NAME, CustomBreadcrumb);

  const headlineProps = JSON.stringify({
    mainTitle,
    subtitle,
    breadcrumbs,
    // 此配置固定为 false。因为旧版 tlw 页面不需要面包屑的 wrap class
    hasWrapClass: false,
  });

  return <custom-breadcrumb headlineProps={headlineProps} {...props} />;
}
